import { Mesh, MeshBasicMaterial, MeshStandardMaterial, Object3D, ShaderMaterial } from 'three'
import * as TWEEN from '@tweenjs/tween.js'
import { ANIMATION_DURATION } from '../../viewerSettings'

export type TweenEasing = 'Sinusoidal' | 'Circular' | 'Quartic'
type Material = MeshBasicMaterial | MeshStandardMaterial | ShaderMaterial

export type TOpacityOption = { opacity: number }

export function animateChangeMeshes(
  meshes: Array<Object3D>,
  delay: number,
  direction: string,
  tweenEasing?: TweenEasing,
  minOpacity?: number,
) {
  const current = { opacity: direction === 'in' ? minOpacity ?? 0.3 : 1 }
  const target = { opacity: direction === 'in' ? 1 : minOpacity ?? 0.3 }

  let easing
  switch (tweenEasing) {
    case 'Sinusoidal': {
      easing = TWEEN.Easing.Sinusoidal
      break
    }
    case 'Circular': {
      easing = TWEEN.Easing.Circular
      break
    }
    case 'Quartic': {
      easing = TWEEN.Easing.Quartic
      break
    }

    default: {
      easing = TWEEN.Easing.Sinusoidal
    }
  }

  if (direction === 'out') {
    for (const mesh of meshes) {
      mesh.visible = true
    }
  }
  const tween = new TWEEN.Tween(current)
    .to(target, ANIMATION_DURATION)
    .easing(direction === 'in' ? easing.In : easing.Out)
    .onStart(() => {
      for (const mesh of meshes) {
        ;((mesh as Mesh).material as Material).transparent = true

        if (direction === 'in') {
          mesh.visible = true
        }
      }
    })
    .onUpdate((option) => {
      for (const mesh of meshes) {
        if ((mesh as Mesh).material instanceof ShaderMaterial) {
          ;((mesh as Mesh).material as ShaderMaterial).uniforms._Opacity.value = option.opacity
        } else {
          ;((mesh as Mesh).material as MeshBasicMaterial | MeshStandardMaterial).opacity =
            option.opacity
        }
      }
    })
    .onComplete(() => {
      for (const mesh of meshes) {
        ;((mesh as Mesh).material as Material).transparent = false

        if (direction === 'out') {
          mesh.visible = false
        }
      }
    })
    .delay(delay)
    .start()

  return tween
}
